import { useState, useEffect } from 'react'
import { useApi } from './useApi'

/**
 * Hook for managing reports
 */
export function useReports() {
  const api = useApi()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function getReports() {
    setLoading(true)
    setError(null)
    try {
      const data = await api.get('/reports')
      return data
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function getReport(reportId) {
    setLoading(true)
    setError(null)
    try {
      const data = await api.get(`/reports/${reportId}`)
      return data
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function createReport(reportData) {
    setLoading(true)
    setError(null)
    try {
      const newReport = await api.post('/reports', reportData)
      return newReport
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function updateReport(reportId, reportData) {
    setLoading(true)
    setError(null)
    try {
      const updatedReport = await api.put(`/reports/${reportId}`, reportData)
      return updatedReport
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  async function deleteReport(reportId) {
    setLoading(true)
    setError(null)
    try {
      await api.delete(`/reports/${reportId}`)
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    getReports,
    getReport,
    createReport,
    updateReport,
    deleteReport
  }
}
